// extracted by mini-css-extract-plugin
module.exports = {"link":"CookiesConsent_link__yf4YW","cookiesFooter":"CookiesConsent_cookiesFooter__KN9_9"};